import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForwardMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 17,
	viewBox: "0 0 19 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.99996 7.83334L2.33329 3.66668V12H9.83329V13.6667H2.33329C1.87496 13.6667 1.4826 13.5035 1.15621 13.1771C0.82982 12.8507 0.666626 12.4583 0.666626 12V2.00001C0.666626 1.54168 0.82982 1.14932 1.15621 0.822927C1.4826 0.496538 1.87496 0.333344 2.33329 0.333344H15.6666C16.125 0.333344 16.5173 0.496538 16.8437 0.822927C17.1701 1.14932 17.3333 1.54168 17.3333 2.00001V7.83334H15.6666V3.66668L8.99996 7.83334ZM8.99996 6.16668L15.6666 2.00001H2.33329L8.99996 6.16668ZM14.8333 16.1667L13.6666 15L14.9791 13.6667H11.5V12H14.9791L13.6458 10.6667L14.8333 9.50001L18.1666 12.8333L14.8333 16.1667ZM2.33329 3.66668V12.8333V7.83334V7.89584V2.00001V3.66668Z",
		fill: "white"
	})
});
export default SvgForwardMail;
